import { createContext, useContext } from 'react';
var NavContext =
/*#__PURE__*/
createContext({});

var useNavContext = function useNavContext() {
  return useContext(NavContext);
};

export { NavContext, useNavContext };